import candidate1 from '../assets/img/candidate-wiyanna-big.webp';

const reviews = [
  {
    title: 'Wiyanna van Setten',
    subtitle: 'Technical & Sales Support',
    text: 'Zelf had ik niet een directe achtergrond in de techniek, machine industrie etc. waardoor het voor mij lastig was in deze richting te zoeken naar een baan. Hier heeft Synsel mij ontzettend goed mee geholpen. Zelf had ik niet een directe achtergrond in de techniek, machine industrie etc. waardoor het voor mij lastig was in deze richting te zoeken naar een baan. Hier heeft Synsel mij ontzettend goed mee geholpen.',
    img: {
      src: candidate1,
      alt: 'Wiyanna van Setten'
    },
    url: '#!'
  },
  {
    title: 'Ronald van Lee',
    subtitle: 'International Field Service Engineer',
    text: 'Op LinkedIn kwam ik Synsel Techniek tegen en ik was eigenlijk meteen enthousiast over de manier hoe zij het aanpakken. Ze dachten echt met me mee en gingen op zoek naar een functie die goed bij mij past en een bedrijf waar het goed mee klikt.',
    img: {
      src: candidate1,
      alt: 'Ronald van Lee'
    },
    url: '#!'
  },
  {
    title: 'Rémon Nijenhuis',
    subtitle: 'Mechanical Technician',
    text: 'Contact met Daan, Nicole en Elisabeth is top! Als ik maar een vraag heb of wat dan ook, ik krijg een snelle reactie en antwoord, of het wordt voor me uitgezocht. Niets anders dan tevreden.',
    img: {
      src: candidate1,
      alt: 'Rémon Nijenhuis'
    },
    url: '#!'
  },
  {
    title: 'Mike Witteveen',
    subtitle: 'Technicus Proces Automatisering',
    text: 'Daan en Mathijs hebben op basis van mijn wensen en ambities contact gezocht met Smurfit Kappa en daar werk ik nu met veel plezier als Technicus Proces Automatisering!',
    img: {
      src: candidate1,
      alt: 'Mike Witteveen'
    },
    url: '#!'
  },
  {
    title: 'Andrik van der Molen',
    subtitle: 'Service Monteur',
    text: 'Bij Synsel vond ik het erg fijn dat ik meteen een lijst van 10 bedrijven kreeg die mogelijk bij mij zouden passen. Hieruit kon ik een top 3 aangeven van de bedrijven die ik het meest interessant vond.',
    img: {
      src: candidate1,
      alt: 'Andrik van der Molen'
    },
    url: '#!'
  },
  {
    title: 'Bas Kloppers',
    subtitle: 'Monteur Technische Dienst',
    text: 'Inmiddels werk ik bijna een jaar met veel plezier als onderhoudsmonteur in de technische dienst van Nestle. Dat heb ik mede aan Synsel te danken!',
    img: {
      src: candidate1,
      alt: 'Bas Kloppers'
    },
    url: '#!'
  },
  {
    title: 'Yannick Luitjens',
    subtitle: 'Control Engineer',
    text: 'Voor mij was uiteindelijk de positiviteit en het enthousiasme van Synsel met daarbij het gevoel dat Synsel voor mij een passende uitdaging kon vinden de beslissende factor.',
    img: {
      src: candidate1,
      alt: 'Yannick Luitjens'
    },
    url: '#!'
  },
  {
    title: 'Robin Huiskamp',
    subtitle: 'Mechanical Engineer',
    text: 'Ik ben bij Synsel gaan werken, omdat ik op zoek was naar een nieuwe uitdaging. Samen met Joost hebben we een perfect aansluitende functie voor mij gevonden.',
    img: {
      src: candidate1,
      alt: 'Robin Huiskamp'
    },
    url: '#!'
  },
  {
    title: 'Koen Willems',
    subtitle: 'Software Engineer/PLC Engineer',
    text: 'Ik raad werken bij Synsel zeker aan als je zoekt naar een baan, maar niet de juiste vacature kunt vinden. Synsel kan die baan vaak wel bieden.',
    img: {
      src: candidate1,
      alt: 'Koen Willems'
    },
    url: '#!'
  },
  {
    title: 'Joost Gilbers',
    subtitle: 'Monteur (service)',
    text: 'Nadat ik had gesolliciteerd, werd ik gebeld en verliep het contact erg soepel. Ze handelden snel en mijn wensen werden echt serieus genomen.',
    img: {
      src: candidate1,
      alt: 'Joost Gilbers'
    },
    url: '#!'
  },
  {
    title: 'Elmar Koopman',
    subtitle: 'Procesoperator',
    text: 'Het was vooral fijn om bij verschillende bedrijven op gesprek te gaan, want zo kon ik een goede afweging maken en was mijn keuze voor VDL Weweler de beste.',
    img: {
      src: candidate1,
      alt: 'Elmar Koopman'
    },
    url: '#!'
  }
];
export default reviews;
